"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pricing = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _reactI18next = require("react-i18next");
var _clsx4 = _interopRequireDefault(require("clsx"));
var _lodash = _interopRequireDefault(require("lodash"));
var _Check = _interopRequireDefault(require("@material-ui/icons/Check"));
var _Info = _interopRequireDefault(require("@material-ui/icons/Info"));
var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));
var _ArrowDownward = _interopRequireDefault(require("@material-ui/icons/ArrowDownward"));
var _reactRouterDom = require("react-router-dom");
var _2 = require("..");
var _Input = _interopRequireDefault(require("./Input"));
var Price = _interopRequireWildcard(require("@thingsw/pitta-modules"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var breakpoint = 944;
var useStyles = (0, _core.makeStyles)(function (theme) {
  var _root, _body;
  return {
    root: (_root = {
      marginTop: 56
    }, _defineProperty(_root, theme.breakpoints.up(breakpoint), {
      marginTop: 58
    }), _defineProperty(_root, "backgroundColor", Price.LightColors.primary["0"]), _root),
    rootModal: {
      marginTop: 54
    },
    rootModalMobile: {
      borderTop: "1px solid ".concat(Price.LightColors.primary["6"]),
      marginTop: 54
    },
    body: (_body = {
      padding: "".concat(theme.spacing(3), "px 0")
    }, _defineProperty(_body, theme.breakpoints.up("md"), {
      padding: "".concat(theme.spacing(7.625), "px ").concat(theme.spacing(4), "px")
    }), _defineProperty(_body, "display", "flex"), _defineProperty(_body, "flexDirection", "column"), _defineProperty(_body, "alignItems", "center"), _body),
    modalBody: _defineProperty({
      padding: "".concat(theme.spacing(3), "px 0")
    }, theme.breakpoints.up("md"), {
      padding: "0px 9px"
    }),
    bodyText: {
      maxWidth: 906,
      textAlign: "center"
    },
    marginT2: {
      marginTop: theme.spacing(2)
    },
    marginB3: {
      marginBottom: theme.spacing(3)
    },
    marginB26: {
      marginBottom: theme.spacing(3) + 2
    },
    marginB5: {
      marginBottom: theme.spacing(5)
    },
    marginB2: {
      marginBottom: theme.spacing(2)
    },
    pricingAcc: _defineProperty({
      display: "flex",
      width: "100%",
      marginTop: theme.spacing(5),
      flexDirection: "column"
    }, theme.breakpoints.up(breakpoint), {
      flexDirection: "row"
    }),
    modalPricingAcc: {
      marginTop: theme.spacing(4)
    },
    accordionRoot: _defineProperty({
      margin: 0,
      borderTop: "1px solid ".concat(Price.LightColors.primary["6"]),
      "&:last-child": {
        marginRight: 0,
        borderBottom: "1px solid ".concat(Price.LightColors.primary["6"])
      },
      "&.Mui-expanded": {
        marginTop: 0,
        marginBottom: 0,
        "&:last-child": {
          marginRight: 0
        }
      },
      "&:before": {
        height: 0
      }
    }, theme.breakpoints.up(breakpoint), {
      width: "33.33%",
      borderRadius: 4,
      marginRight: theme.spacing(4),
      boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.05), 0px 3px 15px rgba(0, 0, 0, 0.1), 0px 0px 8px rgba(0, 0, 0, 0.08)",
      "&.Mui-expanded": {
        marginRight: theme.spacing(4)
      }
    }),
    accordionSummaryRoot: _defineProperty({
      padding: "24px 16px",
      minHeight: 0,
      "&.Mui-expanded": {
        padding: "23px 16px 16px 16px",
        minHeight: 0
      }
    }, theme.breakpoints.up(breakpoint), {
      padding: "24px 24px 16px 24px",
      "&.Mui-expanded": {
        padding: "24px 24px 16px 24px"
      }
    }),
    accordionSummaryContent: {
      margin: 0,
      "&.Mui-expanded": {
        margin: 0
      }
    },
    accordionSummaryexpandIcon: {
      padding: 3,
      paddingRight: 12,
      "&.Mui-expanded": {
        padding: 3,
        paddingLeft: 12
      }
    },
    accordionDetailsRoot: _defineProperty({
      display: "flex",
      flexDirection: "column",
      padding: "0 16px 16px 16px"
    }, theme.breakpoints.up(breakpoint), {
      padding: "0 24px 24px 24px"
    }),
    featureDiv: {
      marginTop: 14
    },
    feature: {
      display: "flex",
      marginBottom: theme.spacing(2)
    },
    featureTline: {
      display: "flex",
      justifyContent: "space-between"
    },
    descDiv: {
      marginLeft: theme.spacing(4)
    },
    checkIcon: {
      marginRight: theme.spacing(1)
    },
    appAnchor: {
      display: "flex"
    },
    appStoreDiv: {
      display: "flex"
    },
    compareDiv: _defineProperty({
      width: "100%",
      marginTop: theme.spacing(5),
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: theme.spacing(0, 2)
    }, theme.breakpoints.up(breakpoint), {
      marginTop: theme.spacing(8),
      padding: theme.spacing(0)
    }),
    tableRoot: {
      borderRadius: 4,
      border: "1px solid ".concat(Price.LightColors.primary["6"]),
      borderCollapse: "separate"
    },
    compareTline: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    },
    compareTitleTline: {
      verticalAlign: "top"
    },
    compareFeatureTitle: {
      display: "flex",
      justifyContent: "space-between"
    },
    compareCheckDiv: {
      display: "flex",
      justifyContent: "center"
    },
    compareCheckIcon: {
      display: "block"
    },
    titleDiv: {
      display: "flex",
      flexDirection: "column",
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    },
    infoIcon: {
      color: Price.LightColors.primary["3"],
      "&:hover, &:active": {
        color: Price.LightColors.primary["1"]
      }
    },
    calcDiv: _defineProperty({
      display: "flex",
      width: "100%",
      flexDirection: "column"
    }, theme.breakpoints.up(breakpoint), {
      flexDirection: "row"
    }),
    calculator: _defineProperty({
      flex: 1.43,
      padding: theme.spacing(3, 2),
      border: "1px solid ".concat(Price.LightColors.primary["6"]),
      borderRadius: theme.spacing(0.5, 0.5, 0, 0)
    }, theme.breakpoints.up(breakpoint), {
      padding: theme.spacing(13.25, 8),
      borderRadius: theme.spacing(0.5, 0, 0, 0.5)
    }),
    camNumDiv: _defineProperty({
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginBottom: theme.spacing(2)
    }, theme.breakpoints.up(breakpoint), {
      flexDirection: "row",
      marginBottom: theme.spacing(4)
    }),
    camNumTitle: _defineProperty({
      flexGrow: 1,
      marginBottom: theme.spacing(2)
    }, theme.breakpoints.up(breakpoint), {
      marginBottom: theme.spacing(0)
    }),
    camNumInput: _defineProperty({}, theme.breakpoints.up(breakpoint), {
      minWidth: 173,
      maxWidth: 173
    }),
    calcResultDiv: _defineProperty({
      flex: 1,
      display: "flex",
      flexDirection: "column",
      backgroundColor: Price.LightColors.primary["10"],
      border: "1px solid ".concat(Price.LightColors.primary["6"]),
      padding: theme.spacing(3, 2),
      borderRadius: theme.spacing(0, 0, 0.5, 0.5)
    }, theme.breakpoints.up(breakpoint), {
      padding: theme.spacing(4, 8),
      borderRadius: theme.spacing(0, 0.5, 0.5, 0)
    }),
    calcArrowDiv: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: Price.LightColors.primary["7"],
      marginTop: theme.spacing(3),
      "&:hover": {
        color: Price.LightColors.primary["8"]
      },
      cursor: "pointer"
    },
    modal: {
      marginTop: theme.spacing(4)
    },
    modalBottom: {
      padding: theme.spacing(0.5, 2, 1.625, 3)
    }
  };
});
var TableCell = (0, _core.withStyles)(function (theme) {
  return {
    body: {
      border: 0,
      padding: "".concat(theme.spacing(1.5), "px ").concat(theme.spacing(3), "px"),
      borderRight: "1px solid ".concat(Price.LightColors.primary["6"]),
      "&:last-child": {
        backgroundColor: Price.LightColors.primary["10"]
      }
    },
    head: {
      padding: theme.spacing(2),
      paddingBottom: 13,
      border: 0
    }
  };
})(_core.TableCell);
var TableRow = (0, _core.withStyles)(function (theme) {
  return {
    root: {
      "&:first-child > td": {
        paddingTop: theme.spacing(3)
      },
      "&:last-child > td": {
        paddingBottom: theme.spacing(3)
      }
    }
  };
})(_core.TableRow);
var Pricing = function Pricing(props) {
  var _clsx, _clsx3;
  var classes = useStyles();
  var modal = props.modal,
    onClickFleet = props.onClickFleet,
    planName = props.planName,
    freetrial = props.freetrial,
    servicePlanID = props.servicePlanID;
  var theme = (0, _core.useTheme)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var history = (0, _reactRouterDom.useHistory)();
  var calcDivRef = (0, _react.useRef)(null);
  var matches = (0, _core.useMediaQuery)(theme.breakpoints.up("md"));
  var mobile = (0, _core.useMediaQuery)(theme.breakpoints.down(breakpoint));
  var category = matches ? "Large" : "Default";
  var _React$useState = _react.default.useState("all"),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    expanded = _React$useState2[0],
    setExpanded = _React$useState2[1];
  var _useState = (0, _react.useState)(1),
    _useState2 = _slicedToArray(_useState, 2),
    camCnt = _useState2[0],
    setCamCnt = _useState2[1];
  (0, _react.useEffect)(function () {
    if (mobile) {
      setExpanded("free");
    } else {
      setExpanded("all");
    }
  }, [mobile]);
  var handleChange = function handleChange(panel) {
    return function (event, isExpanded) {
      setExpanded(isExpanded ? panel : false);
    };
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx4.default)(classes.root, (_clsx = {}, _defineProperty(_clsx, classes.rootModal, modal), _defineProperty(_clsx, classes.rootModalMobile, modal && mobile), _clsx)),
    dir: theme.direction
  }, /*#__PURE__*/_react.default.createElement(_2.Container, {
    className: (0, _clsx4.default)(classes.body, modal && classes.modalBody)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.titleDiv
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: modal ? "Default" : category,
    variant: "H1",
    className: (0, _clsx4.default)(classes.bodyText, modal && classes.marginB2, !mobile && classes.marginB26, mobile && classes.marginB2)
  }, t("Pricing")), modal ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "BodyBold",
    className: classes.bodyText
  }, t("You are subscribed_free")), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body",
    className: classes.bodyText
  }, t("With Alert Push_"))) : /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body",
    className: classes.bodyText
  }, t("Get started now_")), !modal && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.calcArrowDiv,
    onClick: function onClick() {
      //@ts-ignore
      window.location = "/pricing#calculator";
      if (calcDivRef.current) {
        window.scrollTo(0, calcDivRef.current.offsetTop);
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "BodyBold"
  }, t("Calculate your Fleet_")), /*#__PURE__*/_react.default.createElement(_ArrowDownward.default, null))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx4.default)(classes.pricingAcc, _defineProperty({}, classes.modal, modal))
  }, /*#__PURE__*/_react.default.createElement(_core.Accordion, {
    classes: {
      root: classes.accordionRoot
    },
    expanded: _lodash.default.includes(["all", "free"], expanded),
    elevation: 0,
    square: mobile,
    onChange: mobile ? handleChange("free") : undefined
  }, /*#__PURE__*/_react.default.createElement(_core.AccordionSummary, {
    classes: {
      root: classes.accordionSummaryRoot,
      content: classes.accordionSummaryContent,
      expandIcon: classes.accordionSummaryexpandIcon
    },
    expandIcon: mobile && /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null),
    "aria-controls": "free-content",
    id: "free-header"
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: mobile ? "H2" : "H1"
  }, t("Free"))), /*#__PURE__*/_react.default.createElement(_core.AccordionDetails, {
    classes: {
      root: (0, _clsx4.default)(classes.accordionDetailsRoot)
    }
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Small"
  }, t("Get started for_")), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: mobile ? "H2" : "H1",
    style: {
      marginTop: mobile ? 24 : 45
    }
  }, "0 USD"), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Small",
    htmlColor: Price.LightColors.primary["2"]
  }, t("Free forever")), modal ? /*#__PURE__*/_react.default.createElement(_2.Button, {
    fullWidth: true,
    color: "primary",
    style: {
      marginTop: theme.spacing(2)
    },
    onClick: function onClick() {
      return history.push("/signup", {
        mode: "free"
      });
    },
    disabled: modal
  }, t("Subscribed")) : /*#__PURE__*/_react.default.createElement(_2.Button, {
    fullWidth: true,
    color: "primary",
    style: {
      marginTop: theme.spacing(2)
    },
    onClick: function onClick() {
      return history.push("/signup", {
        mode: "free"
      });
    }
  }, t("Get started")), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body",
    style: {
      marginTop: mobile ? theme.spacing(3) : theme.spacing(6)
    }
  }, t("Features included:")), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.featureDiv
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.feature
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.checkIcon
  }), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Camera registration"))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.feature
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.checkIcon
  }), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Live view"))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.feature
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.checkIcon
  }), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Remote video playback_"))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.feature
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.checkIcon
  }), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Cloud Storage"))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.feature
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.checkIcon
  }), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Push Notifications"))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.feature
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.checkIcon
  }), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Two-way voice_"))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.feature
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.checkIcon
  }), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Live GPS"))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginBottom: theme.spacing(2) - 2
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.featureTline
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.feature,
    style: {
      marginBottom: 0
    }
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.checkIcon
  }), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Event live auto_"))), /*#__PURE__*/_react.default.createElement(_2.Tooltip, {
    title: /*#__PURE__*/_react.default.createElement(_2.Typography, {
      category: "Default",
      variant: "Caption"
    }, t("When an Event_")),
    placement: "right"
  }, /*#__PURE__*/_react.default.createElement(_Info.default, {
    className: classes.infoIcon
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.descDiv
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Caption",
    htmlColor: Price.LightColors.primary["2"]
  }, t("Compatible with_")))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginBottom: theme.spacing(2) - 2
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.featureTline
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.feature,
    style: {
      marginBottom: 0
    }
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.checkIcon
  }), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Event file auto_"))), /*#__PURE__*/_react.default.createElement(_2.Tooltip, {
    title: /*#__PURE__*/_react.default.createElement(_2.Typography, {
      category: "Default",
      variant: "Caption"
    }, t("Event File Auto-upload_")),
    placement: "right"
  }, /*#__PURE__*/_react.default.createElement(_Info.default, {
    className: classes.infoIcon
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.descDiv
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Caption",
    htmlColor: Price.LightColors.primary["2"]
  }, t("Not compatible with_")))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginBottom: theme.spacing(2) - 6
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.featureTline
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.feature,
    style: {
      marginBottom: 0
    }
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.checkIcon
  }), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Live event upload"))), /*#__PURE__*/_react.default.createElement(_2.Tooltip, {
    title: /*#__PURE__*/_react.default.createElement(_2.Typography, {
      category: "Default",
      variant: "Caption"
    }, t("When an event_")),
    placement: "right"
  }, /*#__PURE__*/_react.default.createElement(_Info.default, {
    className: classes.infoIcon
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.descDiv
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Caption",
    htmlColor: Price.LightColors.primary["2"]
  }, t("Requires latest firmware_")))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.featureTline
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.feature,
    style: {
      marginBottom: 0
    }
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.checkIcon
  }), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Reports")))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.descDiv
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Caption",
    htmlColor: Price.LightColors.primary["2"]
  }, t("Not compatible with_")))))), /*#__PURE__*/_react.default.createElement(_core.Accordion, {
    classes: {
      root: classes.accordionRoot
    },
    elevation: 0,
    expanded: _lodash.default.includes(["all", "smart"], expanded),
    square: mobile,
    onChange: mobile ? handleChange("smart") : undefined
  }, /*#__PURE__*/_react.default.createElement(_core.AccordionSummary, {
    classes: {
      root: classes.accordionSummaryRoot,
      content: classes.accordionSummaryContent,
      expandIcon: classes.accordionSummaryexpandIcon
    },
    expandIcon: mobile && /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null),
    "aria-controls": "smart-content",
    id: "smart-header"
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: mobile ? "H2" : "H1"
  }, t("Smart"))), /*#__PURE__*/_react.default.createElement(_core.AccordionDetails, {
    classes: {
      root: classes.accordionDetailsRoot
    }
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Small"
  }, t("Get unlimited Remote_")), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "SmallBold"
  }, t("In-app subscription only")), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: mobile ? 24 : 45
    }
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: mobile ? "H2" : "H1"
  }, Price.SMART, " USD"), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Small"
  }, "/mo")), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Small",
    htmlColor: Price.LightColors.primary["2"]
  }, t("+9 USD for extra camera")), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx4.default)(classes.appStoreDiv, classes.marginT2)
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: Price.APPSTORE,
    className: classes.appAnchor,
    target: "_blank",
    rel: "noreferrer",
    style: {
      marginRight: theme.spacing(2)
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    srcSet: "/images/appstore-badge.png 1x, /images/appstore-badge@2x.png 2x",
    alt: "download on the app store"
  })), /*#__PURE__*/_react.default.createElement("a", {
    href: Price.GOOGLEPLAY,
    className: classes.appAnchor,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement("img", {
    srcSet: "/images/google-play-badge.png 1x, /images/google-play-badge@2x.png 2x",
    alt: "get it on google play"
  }))), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body",
    style: {
      marginTop: mobile ? theme.spacing(3) : theme.spacing(6)
    },
    dangerouslySetInnerHTML: {
      __html: t("All the Free_")
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.featureDiv
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.feature
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.checkIcon
  }), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("More cameras"))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.feature
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.checkIcon
  }), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Unlimited Live view"))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.feature
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.checkIcon
  }), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Unlimited remote video_"))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.feature
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.checkIcon
  }), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("More cloud storage"))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.feature
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.checkIcon
  }), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("GPS tracking"))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginBottom: theme.spacing(2) - 1
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.featureTline
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.feature,
    style: {
      marginBottom: 0
    }
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.checkIcon
  }), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Longer storage period_live")))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.descDiv
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Caption",
    htmlColor: Price.LightColors.primary["2"]
  }, t("Compatible with_")))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginBottom: theme.spacing(2) - 2
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.featureTline
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.feature,
    style: {
      marginBottom: 0
    }
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.checkIcon
  }), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Longer storage period_file")))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.descDiv
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Caption",
    htmlColor: Price.LightColors.primary["2"]
  }, t("Not compatible with_")))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginBottom: theme.spacing(1)
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.featureTline
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.feature,
    style: {
      marginBottom: 0
    }
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.checkIcon
  }), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Longer storage period_event")))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.descDiv
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Caption",
    htmlColor: Price.LightColors.primary["2"]
  }, t("Requires latest firmware_"))))))), /*#__PURE__*/_react.default.createElement(_core.Accordion, {
    classes: {
      root: classes.accordionRoot
    },
    expanded: _lodash.default.includes(["all", "fleet"], expanded),
    elevation: 0,
    square: mobile,
    onChange: mobile ? handleChange("fleet") : undefined,
    style: {
      backgroundColor: Price.LightColors.primary["10"]
    }
  }, /*#__PURE__*/_react.default.createElement(_core.AccordionSummary, {
    classes: {
      root: classes.accordionSummaryRoot,
      content: classes.accordionSummaryContent,
      expandIcon: classes.accordionSummaryexpandIcon
    },
    expandIcon: mobile && /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null),
    "aria-controls": "fleet-content",
    id: "fleet-header"
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: mobile ? "H2" : "H1"
  }, t("Fleet"))), /*#__PURE__*/_react.default.createElement(_core.AccordionDetails, {
    classes: {
      root: classes.accordionDetailsRoot
    }
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Small"
  }, t("BlackVue Fleet Tracking_")), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "SmallBold"
  }, t("Web subscription only")), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: 24
    }
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: mobile ? "H2" : "H1"
  }, Price.FLEET_PRICE, " USD"), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Small"
  }, "/mo")), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Small",
    htmlColor: Price.LightColors.primary["2"]
  }, t("+15 USD for extra camera")), /*#__PURE__*/_react.default.createElement(_2.Button, {
    fullWidth: true,
    color: "primary",
    style: {
      marginTop: theme.spacing(2)
    },
    onClick: onClickFleet
  }, (servicePlanID === 1 || planName === "Smart plan" || planName === "Basic plan") && freetrial ? t("subscribe") : t("Try 1 month free")), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body",
    style: {
      marginTop: mobile ? theme.spacing(3) : theme.spacing(6)
    },
    dangerouslySetInnerHTML: {
      __html: t("All the Smart_")
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.featureDiv
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.feature
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.checkIcon
  }), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("More cameras"))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.feature
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.checkIcon
  }), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("More users"))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.feature
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.checkIcon
  }), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Roles and permissions"))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.feature
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.checkIcon
  }), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("More cloud storage"))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.feature
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.checkIcon
  }), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Email notifications"))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.feature
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.checkIcon
  }), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Multi Live view (web/desktop)"))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.feature
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.checkIcon
  }), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Longer GPS Tracking"))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.feature
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.checkIcon
  }), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Event live auto upload_"))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.feature
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.checkIcon
  }), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Geofence setup (web/desktop)_"))))))), !mobile && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.compareDiv
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "H1",
    className: (0, _clsx4.default)(classes.bodyText, classes.marginB3)
  }, t("How our plans compare")), /*#__PURE__*/_react.default.createElement(_core.Table, {
    "aria-label": "simple table"
  }, /*#__PURE__*/_react.default.createElement(_core.TableHead, null, /*#__PURE__*/_react.default.createElement(TableRow, null, /*#__PURE__*/_react.default.createElement(TableCell, {
    style: {
      width: "24.42%"
    }
  }), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center",
    style: {
      width: "25.58%"
    }
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "H6"
  }, t("Free"))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center",
    style: {
      width: "25.58%"
    }
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "H6"
  }, t("Smart"))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center",
    style: {
      width: "24.35%"
    }
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "H6"
  }, t("Fleet")))))), /*#__PURE__*/_react.default.createElement(_core.Table, {
    classes: {
      root: classes.tableRoot
    }
  }, /*#__PURE__*/_react.default.createElement(_core.TableBody, null, /*#__PURE__*/_react.default.createElement(TableRow, null, /*#__PURE__*/_react.default.createElement(TableCell, {
    style: {
      width: "24.42%"
    }
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Cameras per account"))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center",
    style: {
      width: "25.58%"
    }
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, "1")), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center",
    style: {
      width: "25.58%"
    }
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, "3")), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center",
    style: {
      width: "24.35%"
    }
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, "999"))), /*#__PURE__*/_react.default.createElement(TableRow, null, /*#__PURE__*/_react.default.createElement(TableCell, null, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Users per account"))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, "1")), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, "1")), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Owner"), ": 1"), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Admin"), ": 10"), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Driver"), ": 3 ", t("per camera")))), /*#__PURE__*/_react.default.createElement(TableRow, null, /*#__PURE__*/_react.default.createElement(TableCell, null, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Live view per day"))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, "10 ", t("minutes"))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Unlimited"))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Unlimited")))), /*#__PURE__*/_react.default.createElement(TableRow, null, /*#__PURE__*/_react.default.createElement(TableCell, null, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Remote video playback and download per month"))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center",
    className: classes.compareTitleTline
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, "100 ", t("times"))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center",
    className: classes.compareTitleTline
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Unlimited"))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center",
    className: classes.compareTitleTline
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Unlimited")))), /*#__PURE__*/_react.default.createElement(TableRow, null, /*#__PURE__*/_react.default.createElement(TableCell, null, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Cloud storage"))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("GB", {
    a: 5
  }))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("GB", {
    a: 5
  }), " ", t("per camera"))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("GB", {
    a: 15
  }), " ", t("per camera")))), /*#__PURE__*/_react.default.createElement(TableRow, null, /*#__PURE__*/_react.default.createElement(TableCell, null, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Push Notifications"))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.compareCheckDiv
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.compareCheckIcon
  }))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.compareCheckDiv
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.compareCheckIcon
  }))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.compareCheckDiv
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.compareCheckIcon
  })))), /*#__PURE__*/_react.default.createElement(TableRow, null, /*#__PURE__*/_react.default.createElement(TableCell, null, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Two-way voice_"))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.compareCheckDiv
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.compareCheckIcon
  }))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.compareCheckDiv
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.compareCheckIcon
  }))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.compareCheckDiv
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.compareCheckIcon
  })))), /*#__PURE__*/_react.default.createElement(TableRow, null, /*#__PURE__*/_react.default.createElement(TableCell, null, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Live GPS"))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.compareCheckDiv
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.compareCheckIcon
  }))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.compareCheckDiv
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.compareCheckIcon
  }))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.compareCheckDiv
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.compareCheckIcon
  })))), /*#__PURE__*/_react.default.createElement(TableRow, null, /*#__PURE__*/_react.default.createElement(TableCell, null, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Email notifications"))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.compareCheckDiv
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.compareCheckIcon
  })))), /*#__PURE__*/_react.default.createElement(TableRow, null, /*#__PURE__*/_react.default.createElement(TableCell, null, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Multi Live view (web/desktop)"))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.compareCheckDiv
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.compareCheckIcon
  })))), /*#__PURE__*/_react.default.createElement(TableRow, null, /*#__PURE__*/_react.default.createElement(TableCell, null, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("GPS tracking"))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("days", {
    a: 7
  }))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("days", {
    a: 90
  })))), /*#__PURE__*/_react.default.createElement(TableRow, null, /*#__PURE__*/_react.default.createElement(TableCell, null, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Geofence setup (web/desktop) and alerts"))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center",
    className: classes.compareTitleTline
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.compareCheckDiv
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.compareCheckIcon
  })))), /*#__PURE__*/_react.default.createElement(TableRow, null, /*#__PURE__*/_react.default.createElement(TableCell, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.compareFeatureTitle,
    style: {
      marginBottom: 16
    }
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Event live auto_")), /*#__PURE__*/_react.default.createElement(_2.Tooltip, {
    title: /*#__PURE__*/_react.default.createElement(_2.Typography, {
      category: "Default",
      variant: "Caption"
    }, t("When an Event_")),
    placement: "right"
  }, /*#__PURE__*/_react.default.createElement(_Info.default, {
    className: classes.infoIcon
  })))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.compareTline
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body",
    style: {
      marginBottom: 2
    }
  }, t("days", {
    a: 7
  })), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Caption",
    htmlColor: Price.LightColors.primary["2"]
  }, t("DR650S Series only")))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.compareTline
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body",
    style: {
      marginBottom: 2
    }
  }, t("days", {
    a: 30
  })), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Caption",
    htmlColor: Price.LightColors.primary["2"]
  }, t("DR650S Series only")))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.compareTline
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body",
    style: {
      marginBottom: 2
    }
  }, t("days", {
    a: 30
  })), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Caption",
    htmlColor: Price.LightColors.primary["2"]
  }, t("All Cloud dashcams except DR650GW Series"))))), /*#__PURE__*/_react.default.createElement(TableRow, null, /*#__PURE__*/_react.default.createElement(TableCell, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.compareFeatureTitle,
    style: {
      marginBottom: 16
    }
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Event file auto_")), /*#__PURE__*/_react.default.createElement(_2.Tooltip, {
    title: /*#__PURE__*/_react.default.createElement(_2.Typography, {
      category: "Default",
      variant: "Caption"
    }, t("Event File Auto-upload_")),
    placement: "right"
  }, /*#__PURE__*/_react.default.createElement(_Info.default, {
    className: classes.infoIcon
  })))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.compareTline
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body",
    style: {
      marginBottom: 2
    }
  }, t("days", {
    a: 7
  })), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Caption",
    htmlColor: Price.LightColors.primary["2"],
    style: {
      whiteSpace: mobile ? "nowrap" : "normal"
    }
  }, t("Not compatible with_")))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.compareTline
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body",
    style: {
      marginBottom: 2
    }
  }, t("days", {
    a: 30
  })), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Caption",
    htmlColor: Price.LightColors.primary["2"]
  }, t("Not compatible with_")))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.compareTline
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body",
    style: {
      marginBottom: 2
    }
  }, t("days", {
    a: 30
  })), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Caption",
    htmlColor: Price.LightColors.primary["2"]
  }, t("Not compatible with_"))))), /*#__PURE__*/_react.default.createElement(TableRow, null, /*#__PURE__*/_react.default.createElement(TableCell, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.featureTline
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.feature,
    style: {
      marginBottom: 0
    }
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Live event upload"))), /*#__PURE__*/_react.default.createElement(_2.Tooltip, {
    title: /*#__PURE__*/_react.default.createElement(_2.Typography, {
      category: "Default",
      variant: "Caption"
    }, t("When an event_")),
    placement: "right"
  }, /*#__PURE__*/_react.default.createElement(_Info.default, {
    className: classes.infoIcon
  }))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Caption",
    htmlColor: Price.LightColors.primary["2"]
  }, t("Requires latest firmware")))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.compareTline
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body",
    style: {
      marginBottom: 2
    }
  }, t("days", {
    a: 7
  })), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Caption",
    htmlColor: Price.LightColors.primary["2"]
  }, t("Not compatible with_")))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.compareTline
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body",
    style: {
      marginBottom: 2
    }
  }, t("days", {
    a: 30
  })), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Caption",
    htmlColor: Price.LightColors.primary["2"]
  }, t("Not compatible with_")))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.compareTline
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body",
    style: {
      marginBottom: 2
    }
  }, t("days", {
    a: 30
  })), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Caption",
    htmlColor: Price.LightColors.primary["2"]
  }, t("Not compatible with_"))))), /*#__PURE__*/_react.default.createElement(TableRow, null, /*#__PURE__*/_react.default.createElement(TableCell, {
    className: classes.compareTitleTline
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Body"
  }, t("Reports"))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center",
    style: {
      paddingLeft: 6
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.compareTline
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.compareCheckDiv
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.compareCheckIcon
  })), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Caption",
    htmlColor: Price.LightColors.primary["2"],
    style: {
      marginTop: 4
    }
  }, t("Not compatible with_")))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center",
    style: {
      paddingLeft: 6
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.compareTline
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.compareCheckDiv
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.compareCheckIcon
  })), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Caption",
    htmlColor: Price.LightColors.primary["2"],
    style: {
      marginTop: 4
    }
  }, t("Not compatible with_")))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.compareTline
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.compareCheckDiv
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "primary",
    className: classes.compareCheckIcon
  })), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Caption",
    htmlColor: Price.LightColors.primary["2"],
    style: {
      marginTop: 4
    }
  }, t("Not compatible with_"))))), /*#__PURE__*/_react.default.createElement(TableRow, null, /*#__PURE__*/_react.default.createElement(TableCell, null), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement(_2.Button, {
    fullWidth: true,
    color: "primary",
    onClick: function onClick() {
      return history.push("/signup", {
        mode: "free"
      });
    },
    disabled: modal
  }, modal ? t("Subscribed") : t("Get started"))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx4.default)(classes.appStoreDiv, classes.compareCheckDiv)
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: Price.APPSTORE,
    className: classes.appAnchor,
    target: "_blank",
    rel: "noreferrer",
    style: {
      marginRight: theme.spacing(2)
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    srcSet: "/images/appstore-badge.png 1x, /images/appstore-badge@2x.png 2x",
    alt: "download on the app store"
  })), /*#__PURE__*/_react.default.createElement("a", {
    href: Price.GOOGLEPLAY,
    className: classes.appAnchor,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement("img", {
    srcSet: "/images/google-play-badge.png 1x, /images/google-play-badge@2x.png 2x",
    alt: "get it on google play"
  })))), /*#__PURE__*/_react.default.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement(_2.Button, {
    fullWidth: true,
    color: "primary",
    onClick: onClickFleet
  }, (servicePlanID === 1 || planName === "Smart plan" || planName === "Basic plan") && freetrial ? t("subscribe") : t("Try 1 month free"))))))), !modal && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.compareDiv,
    ref: calcDivRef,
    id: "calculator"
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "H1",
    className: (0, _clsx4.default)(classes.bodyText, (_clsx3 = {}, _defineProperty(_clsx3, classes.marginB5, !mobile), _defineProperty(_clsx3, classes.marginB2, mobile), _clsx3))
  }, t("Calculate your Fleet_")), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.calcDiv
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.calculator
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.camNumDiv
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: mobile ? "H2" : "H1",
    className: classes.camNumTitle
  }, t("Number of cameras")), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.camNumInput
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    type: "numeric",
    count: true,
    pattern: "[0-9]*",
    value: camCnt,
    inputmode: "numeric",
    onPlus: function onPlus() {
      return setCamCnt(function (c) {
        return Math.min(c + 1, Price.MAX_CAM_COUNT);
      });
    },
    onMinus: function onMinus() {
      return setCamCnt(function (c) {
        return Math.max(c - 1, 1);
      });
    },
    onChange: function onChange(event) {
      if (event.target.value === "") {
        setCamCnt(1);
      } else {
        var value = Number.parseInt(event.target.value);
        if (value <= Price.MAX_CAM_COUNT && value > 0) {
          setCamCnt(value);
        }
      }
    }
  }))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_2.Sliders, {
    value: camCnt,
    variant: "large",
    step: 1,
    min: 1,
    max: Price.MAX_CAM_COUNT,
    onChange: function onChange(event, value) {
      return setCamCnt(value);
    },
    marks: [{
      value: 1,
      label: "1"
    }, {
      value: 999,
      label: "999"
    }]
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.calcResultDiv
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: mobile ? "H2" : "H1",
    style: {
      marginBottom: mobile ? theme.spacing(3) : theme.spacing(4)
    }
  }, t("Fleet")), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "H6",
    style: {
      marginBottom: theme.spacing(0.5)
    }
  }, t("Monthly price")), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginBottom: mobile ? theme.spacing(3) : theme.spacing(4)
    }
  }, /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "H1"
  }, (Price.FLEET_PRICE + (camCnt - 1) * Price.FLEET_EXTRA).toFixed(2), " ", "USD"), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Small"
  }, "/mo")), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "H6",
    style: {
      marginBottom: mobile ? theme.spacing(3) : theme.spacing(4)
    }
  }, t("Available cloud storage: 15 GB per camera")), /*#__PURE__*/_react.default.createElement(_2.Button, {
    fullWidth: true,
    color: "primary",
    style: {
      marginBottom: theme.spacing(2)
    },
    onClick: function onClick() {
      return history.push("/signup", {
        mode: "fleet",
        cameraCnt: camCnt
      });
    }
  }, t("Try 1 month free")), /*#__PURE__*/_react.default.createElement(_2.Typography, {
    category: "Default",
    variant: "Caption",
    htmlColor: Price.LightColors.primary["2"],
    style: {
      textAlign: "center"
    }
  }, t("Includes unlimited Live View, Remote video playback, and download.")))))));
};
exports.Pricing = Pricing;